import { render, staticRenderFns } from "./SVGRuler.vue?vue&type=template&id=53c3c94f&scoped=true&"
import script from "./SVGRuler.vue?vue&type=script&lang=js&"
export * from "./SVGRuler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c3c94f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53c3c94f')) {
      api.createRecord('53c3c94f', component.options)
    } else {
      api.reload('53c3c94f', component.options)
    }
    module.hot.accept("./SVGRuler.vue?vue&type=template&id=53c3c94f&scoped=true&", function () {
      api.rerender('53c3c94f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/SVG/SVGRuler.vue"
export default component.exports